import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateConfirmClickedPayload {
  shiftId: string;
  professionalId?: string;
  offerId?: string;
  candidateNumber?: number;
  candidateCount?: number;
}

/**
 * Fires when an office clicks the "Confirm" button on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:confirm_clicked
 */
export function fireConfirmCandidateConfirmClicked(
  payload: IConfirmCandidateConfirmClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:confirm_clicked', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
    offer_id: payload.offerId,
    candidate_number: payload.candidateNumber,
    candidate_count: payload.candidateCount,
  });
}
